/* eslint-disable import/no-deprecated */
import React, { ComponentProps } from 'react';
import { Button } from '../../components/Button';
import { Typography } from '../../deprecated/Typography';
import { identifyComponent } from '../../util';
import css from './index.module.scss';

interface InputGroupLabelProps {
  children: string;
  size?: ComponentProps<typeof Button>['size'];
}

export const InputGroupLabel: React.FunctionComponent<InputGroupLabelProps> = ({
  children,
  size,
}) => (
  <Button
    data-component="InputGroupLabel"
    variant="fill-primary"
    component="span"
    size={size}
    className={css.label}
    disabled
    {...identifyComponent('input-group-label')}
  >
    <Typography variant="body2">{children}</Typography>
  </Button>
);
